<template>
  <v-app>
    <v-main class="hidden-md-and-down">
      <v-row>
        <v-col cols="12" md="1" sm="1" lg="1">
          <NavMenu />
        </v-col>
        <v-spacer />
        <v-col cols="12" md="10" sm="10" lg="10">
          <v-container>
            <div style="margin:30px 110px 30px 110px">
              <div style="max-width:100%">
                <span
                  class="font-weight-bold"
                  style="padding-top:3px;text-decoration:none;font-size:24px"
                >
                  Settings</span
                >
                <color-mode-picker></color-mode-picker>

                <v-row>
                  <v-col cols="12" md="2" sm="2" lg="2">
                    <div class="mt-9">
                      <v-btn
                        @click="step = 1"
                        x-large
                        outlined
                        block
                        width="264px"
                        class="mb-4"
                        ><v-icon class="mr-6">mdi-account</v-icon>Account
                        Settings</v-btn
                      >
                      <v-btn
                        @click="step = 2"
                        x-large
                        outlined
                        block
                        width="264px"
                        class="mb-4"
                        ><v-icon class="mr-11">mdi-palette</v-icon
                        >Customization</v-btn
                      >
                      <v-btn
                        @click="step = 3"
                        x-large
                        outlined
                        block
                        width="264px"
                        class="mb-4"
                        ><v-icon class="mr-6">mdi-bank</v-icon>Payment
                        Settings</v-btn
                      >
                      <v-btn
                        @click="step = 4"
                        x-large
                        outlined
                        block
                        class="mb-4"
                        ><v-icon class="mr-2">mdi-bell</v-icon>Notification
                        settings</v-btn
                      >
                      <v-btn
                        @click="step = 5"
                        x-large
                        outlined
                        block
                        class="mb-4"
                        ><v-icon class="mr-2">mdi-lock</v-icon>Password &
                        Security</v-btn
                      >

                       <v-btn
                        @click="logOut()"
                        x-large
                        width="260px"
                        outlined
                        class="mb-4"
                        ><v-icon class="mr-2">mdi-power-standby</v-icon>Logout</v-btn
                      >
                    </div>
                  </v-col>
                  <v-col cols="12" md="10" sm="10" lg="10">
                    <div style="margin:auto 0px auto 180px">
                      <v-window v-model="step">
                        <!--Account step-->
                        <v-window-item :value="1">
                          <h3 style="font-size:21px">Account</h3>
                      
                          <v-avatar
                            @click="imageModal()"
                            size="80px"
                            style="margin-top:20px"
                          >
                            <v-img :src="image">
                             <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    v-if="imgloading == true"
                    indeterminate
                    color="#f21a3f"
                  ></v-progress-circular>
                </v-row>
                            </v-img>
                          </v-avatar>

                          <input
                            type="file"
                            @change="onFileChanged"
                            accept="image/png, image/jpeg,image/gif"
                            hidden
                            ref="imageUpload"
                          />

                          <v-btn
                            color="grey"
                            style="color:red"
                            outlined
                            class="ml-3"
                            @click="imageModal()"
                            >Upload image</v-btn
                          >
                          <v-form class="mt-4">
                            <v-row>
                              <v-col>
                                <v-text-field
                                  style="border-radius:12px"
                                  solo
                                  v-model="username"
                                  readonly
                                  hint="Sorry, you can't change your username, yet"
                                />
                              </v-col>
                              <v-col>
                                <v-text-field
                                  color="red"
                                  style="border-radius:12px"
                                  outlined
                                  label="Fullname"
                                  v-model="fullname"
                                />
                              </v-col>
                            </v-row>

                            <v-row style="margin-top:-20px">
                              <v-col>
                                <v-text-field
                                  style="border-radius:12px"
                                  color="red"
                                  solo
                                  label="Email address"
                                  v-model="email"
                                  readonly
                                  hint="Sorry, you can't change your email, yet"
                                />
                              </v-col>
                              <v-col>
                                <v-text-field
                                  style="border-radius:12px"
                                  color="red"
                                  outlined
                                  type="Number"
                                  label="Phone Number"
                                  hint="Please include country code"
                                  v-model="phoneNumber"
                                />
                              </v-col>
                            </v-row>
                            <v-textarea
                              style="border-radius:12px"
                              color="red"
                              outlined
                              label="Bio"
                              v-model="bio"
                            />
                          </v-form>

                          <p style="text-decoration:underline">
                            Social media accounts
                          </p>
                          <div>
                            <label>Facebook</label>
                            <v-text-field
                              style="border-radius:12px"
                              color="red"
                              label="yourusername"
                              prefix="https://facebook.com/"
                              prepend-inner-icon="mdi-facebook"
                              outlined
                              v-model="facebook"
                            />
                          </div>
                          <div style="margin-top:-15px">
                            <label>Twitter</label>
                            <v-text-field
                              style="border-radius:12px"
                              color="red"
                              label="yourusername"
                              prefix="https://twitter.com/"
                              prepend-inner-icon="mdi-twitter"
                              outlined
                              v-model="twitter"
                            />
                          </div>
                          <div style="margin-top:-15px">
                            <label>Youtube</label>
                            <v-text-field
                              style="border-radius:12px"
                              color="red"
                              label="yourusername"
                              prefix="https://youtube.com/"
                              prepend-inner-icon="mdi-youtube"
                              outlined
                              v-model="youtube"
                            />
                          </div>
                          <div style="margin-top:-15px">
                            <label>Instagram</label>
                            <v-text-field
                              style="border-radius:12px"
                              color="red"
                              label="yourusername"
                              prefix="https://instagram.com/"
                              prepend-inner-icon="mdi-instagram"
                              outlined
                              v-model="instagram"
                            />
                          </div>
                          <div style="margin-top:-15px">
                            <label>TikTok</label>
                            <v-text-field
                              style="border-radius:12px"
                              color="red"
                              label="yourusername"
                              prefix="https://tiktok.com/"
                              prepend-inner-icon="mdi-music-circle"
                              outlined
                              v-model="tiktok"
                            />
                          </div>
                          <div style="margin-top:-15px">
                            <label>LinkedIn</label>
                            <v-text-field
                              style="border-radius:12px"
                              color="red"
                              label="yourusername"
                              prefix="https://linkedin.com/in/"
                              prepend-inner-icon="mdi-linkedin"
                              outlined
                              v-model="linkedin"
                            />
                          </div>
                          <v-btn
                            block
                            style="border-radius:12px;color:white"
                            x-large
                            color="#e00000"
                            @click="saveProfile()"
                            :loading="btnloading"
                          >
                            Save Profile</v-btn
                          >
                        </v-window-item>
                        <v-window-item :value="2">
                          <h2>Customization</h2>
                          <label style="width:400px;text-align:start">
                            Choose Theme color
                          </label>
                          <v-form>
                            <v-text-field
                              v-model="btncolor"
                              v-mask="mask"
                              hide-details
                              solo
                              style="text-align:start;border-radius:10px;height:60px"
                            >
                              <template v-slot:append>
                                <v-menu
                                  v-model="menuBtn"
                                  top
                                  nudge-bottom="105"
                                  nudge-left="16"
                                  :close-on-content-click="false"
                                  style="text-align:start;margin:auto;border-radius:10px;width:400px;height:60px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <div :style="btnStyle" v-on="on" />
                                  </template>
                                  <v-card>
                                    <v-card-text class="pa-0">
                                      <v-color-picker
                                        v-model="btncolor"
                                        :value="btncolor"
                                        flat
                                      />
                                    </v-card-text>
                                  </v-card>
                                </v-menu>
                              </template>
                            </v-text-field>
                            <br />
                            <label>
                              Choose Background color
                            </label>
                            <v-text-field
                              v-model="bgcolor"
                              v-mask="mask"
                              hide-details
                              solo
                              style="text-align:start;border-radius:10px;height:60px"
                            >
                              <template v-slot:append>
                                <v-menu
                                  v-model="menuBg"
                                  top
                                  nudge-bottom="105"
                                  nudge-left="16"
                                  :close-on-content-click="false"
                                >
                                  <template v-slot:activator="{ on }">
                                    <div :style="bgStyle" v-on="on" />
                                  </template>
                                  <v-card>
                                    <v-card-text class="pa-0">
                                      <v-color-picker
                                        v-model="bgcolor"
                                        :value="bgcolor"
                                        flat
                                      />
                                    </v-card-text>
                                  </v-card>
                                </v-menu>
                              </template>
                            </v-text-field>
                          </v-form>
                          <v-btn
                            x-large
                            block
                            class="mt-10 white--text"
                            style="border-radius:12px"
                            color="#e50914"
                            @click="saveCustomization()"
                            :loading="btnloading"
                          >
                            Update
                          </v-btn>
                        </v-window-item>
                        <!--Payment Details-->
                        <v-window-item :value="3">
                          <Bank :bank="bank" />
                        </v-window-item>

                        <v-window-item :value="4">
                          <Notifications />
                        </v-window-item>
                        <v-window-item :value="5">
                          <Password :email="email" />
                        </v-window-item>
                      </v-window>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>

            <!--No New Notifications-->
          </v-container>
        </v-col>
      </v-row>
    </v-main>

    <!--Mobile view-->
    <v-main class="hidden-lg-and-up">
      <v-container>
        <div class="mt-9">
          <div class="mb-6">
            <color-mode-picker></color-mode-picker>
          </div>

          <v-btn
            @click="showProfile()"
            x-large
            outlined
            block
            width="264px"
            class="mb-4"
            ><v-icon class="mr-6">mdi-account</v-icon>Account Settings</v-btn
          >
          <v-btn
            @click="showCustomization()"
            x-large
            outlined
            block
            width="264px"
            class="mb-4"
            ><v-icon class="mr-11">mdi-palette</v-icon>Customization</v-btn
          >
          <v-btn
            @click="showPayment()"
            x-large
            outlined
            block
            width="264px"
            class="mb-4"
            ><v-icon class="mr-6">mdi-bank</v-icon>Payment Settings</v-btn
          >
          <v-btn
            @click="showNotifications()"
            x-large
            outlined
            block
            class="mb-4"
            ><v-icon class="mr-2">mdi-bell</v-icon>Notification settings</v-btn
          >
          <v-btn @click="showPassword()" x-large outlined block class="mb-4"
            ><v-icon class="mr-2">mdi-lock</v-icon>Password & Security</v-btn
          >

           <v-btn
                        @click="logOut()"
                        x-large
                        outlined
                        block
                        class="mb-4"
                        ><v-icon class="mr-2">mdi-power-standby</v-icon>Logout</v-btn
                      >
        </div>

        <v-bottom-sheet
          height="4000px"
          scrollable
          style="border-radius:20px 20px 0px 0px"
          v-model="sheet"
        >
          <v-card
            height="4000px"
            class="pa-4 pt-7"
            style="border-radius:20px 20px 0px 0px"
          >
            <v-btn
              style="text-align:start"
              small
              @click="sheet = !sheet"
              fab
              depressed
              ><v-icon>mdi-close</v-icon></v-btn
            >
            <v-window v-model="step">
              <v-window-item :value="2">
                <h2>Customization</h2>
                <label style="width:400px;text-align:start">
                  Choose Theme color
                </label>
                <v-form>
                  <v-text-field
                    v-model="btncolor"
                    v-mask="mask"
                    hide-details
                    solo
                    style="text-align:start;border-radius:10px;height:60px"
                  >
                    <template v-slot:append>
                      <v-menu
                        v-model="menuBtn"
                        top
                        nudge-bottom="105"
                        nudge-left="16"
                        :close-on-content-click="false"
                        style="text-align:start;margin:auto;border-radius:10px;width:400px;height:60px"
                      >
                        <template v-slot:activator="{ on }">
                          <div :style="btnStyle" v-on="on" />
                        </template>
                        <v-card>
                          <v-card-text class="pa-0">
                            <v-color-picker
                              v-model="btncolor"
                              :value="btncolor"
                              flat
                            />
                          </v-card-text>
                        </v-card>
                      </v-menu>
                    </template>
                  </v-text-field>
                  <br />
                  <label>
                    Choose Background color
                  </label>
                  <v-text-field
                    v-model="bgcolor"
                    v-mask="mask"
                    hide-details
                    solo
                    style="text-align:start;border-radius:10px;height:60px"
                  >
                    <template v-slot:append>
                      <v-menu
                        v-model="menuBg"
                        top
                        nudge-bottom="105"
                        nudge-left="16"
                        :close-on-content-click="false"
                      >
                        <template v-slot:activator="{ on }">
                          <div :style="bgStyle" v-on="on" />
                        </template>
                        <v-card>
                          <v-card-text class="pa-0">
                            <v-color-picker
                              v-model="bgcolor"
                              :value="bgcolor"
                              flat
                            />
                          </v-card-text>
                        </v-card>
                      </v-menu>
                    </template>
                  </v-text-field>
                </v-form>
                <v-btn
                  x-large
                  block
                  class="mt-10 white--text"
                  style="border-radius:12px"
                  color="#e50914"
                  @click="saveCustomization()"
                  :loading="btnloading"
                >
                  Update
                </v-btn>
              </v-window-item>
              <v-window-item :value="3">
                <Bank :bank="bank" />
              </v-window-item>
              <v-window-item :value="4">
                <Notifications />
              </v-window-item>
              <v-window-item :value="5">
                <Password :email="email" />
              </v-window-item>
            </v-window>
          </v-card>
        </v-bottom-sheet>
        <v-dialog v-model="profile" fullscreen scrollable>
          <v-sheet color="white" height="200%" class="pa-5">
            <v-btn @click="profile = !profile" fab small depressed
              ><v-icon>mdi-close</v-icon></v-btn
            >
            <h3 style="font-size:21px">Account</h3>

            <v-avatar @click="imageModal()" size="80px" style="margin-top:20px">
              <v-img :src="image">
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    v-if="imgloading == true"
                    indeterminate
                    color="#f21a3f"
                  ></v-progress-circular>
                </v-row>
              </v-img>
            </v-avatar>

            <v-btn
              @click="imageModal()"
              color="grey"
              style="color:red"
              outlined
              class="ml-3"
              >Upload image</v-btn
            >

            <input
              type="file"
              @change="onFileChanged"
              accept="image/png, image/jpeg,image/gif"
              hidden
              ref="imageUpload"
            />
            <v-form class="mt-4">
              <v-row>
                <v-col>
                  <v-text-field
                    style="border-radius:12px"
                    solo
                    v-model="username"
                    readonly
                    hint="Sorry, you can't change your username, yet"
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    color="red"
                    style="border-radius:12px"
                    outlined
                    label="Fullname"
                    v-model="fullname"
                  />
                </v-col>
              </v-row>

              <v-row style="margin-top:-20px">
                <v-col>
                  <v-text-field
                    style="border-radius:12px"
                    color="red"
                    solo
                    label="Email address"
                    v-model="email"
                    readonly
                    hint="Sorry, you can't change your email, yet"
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    style="border-radius:12px"
                    color="red"
                    outlined
                    type="Number"
                    label="Phone Number"
                    hint="Please include country code"
                    v-model="phoneNumber"
                  />
                </v-col>
              </v-row>
              <v-textarea
                style="border-radius:12px"
                color="red"
                outlined
                label="Bio"
                v-model="bio"
              />
            </v-form>

            <p style="text-decoration:underline">
              Social media accounts
            </p>
            <div>
              <label>Facebook</label>
              <v-text-field
                style="border-radius:12px"
                color="red"
                label="yourusername"
                prefix="https://facebook.com/"
                prepend-inner-icon="mdi-facebook"
                outlined
                v-model="facebook"
              />
            </div>
            <div style="margin-top:-15px">
              <label>Twitter</label>
              <v-text-field
                style="border-radius:12px"
                color="red"
                label="yourusername"
                prefix="https://twitter.com/"
                prepend-inner-icon="mdi-twitter"
                outlined
                v-model="twitter"
              />
            </div>
            <div style="margin-top:-15px">
              <label>Youtube</label>
              <v-text-field
                style="border-radius:12px"
                color="red"
                label="yourusername"
                prefix="https://youtube.com/"
                prepend-inner-icon="mdi-youtube"
                outlined
                v-model="youtube"
              />
            </div>
            <div style="margin-top:-15px">
              <label>Instagram</label>
              <v-text-field
                style="border-radius:12px"
                color="red"
                label="yourusername"
                prefix="https://instagram.com/"
                prepend-inner-icon="mdi-instagram"
                outlined
                v-model="instagram"
              />
            </div>
            <div style="margin-top:-15px">
              <label>TikTok</label>
              <v-text-field
                style="border-radius:12px"
                color="red"
                label="yourusername"
                prefix="https://tiktok.com/"
                prepend-inner-icon="mdi-music-circle"
                outlined
                v-model="tiktok"
              />
            </div>
            <div style="margin-top:-15px">
              <label>LinkedIn</label>
              <v-text-field
                style="border-radius:12px"
                color="red"
                label="yourusername"
                prefix="https://linkedin.com/in/"
                prepend-inner-icon="mdi-linkedin"
                outlined
                v-model="linkedin"
              />
            </div>
            <v-btn
              block
              style="border-radius:12px;color:white"
              x-large
              color="#e00000"
              @click="saveProfile()"
              :loading="btnloading"
            >
              Save Profile</v-btn
            >
          </v-sheet>
        </v-dialog>
      </v-container>
    </v-main>
    <BottomMenu class="hidden-lg-and-up" />
  </v-app>
</template>

<script>
import NavMenu from "@/components/NavMenu";
import { mapGetters } from "vuex";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import Bank from "@/components/Bank";
import Notifications from "@/components/Notifications";
import db from "@/db";
import BottomMenu from "@/components/BottomMenu";
import Password from "@/components/Password";
import ColorModePicker from "@/components/ColorModePicker";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";

import { getAuth, updateProfile,signOut,onAuthStateChanged } from "firebase/auth";


export default {
  name: "Settings",
  data() {
    return {
      step: 1,
      fullname: "",
      email: "",
      phoneNumber:"",
      username: "",
      facebook: "",
      twitter: "",
      instagram: "",
      youtube: "",
      tiktok: "",
      linkedin: "",
      types: ["hex"],
      type: "hex",
      hex: "#FF00FF",
      hexa: "#FF00FFFF",
      rgba: { r: 255, g: 0, b: 255, a: 1 },
      hsla: { h: 300, s: 1, l: 0.5, a: 1 },
      hsva: { h: 300, s: 1, v: 1, a: 1 },
      hover: false,
      mask: "!#XXXXXXXX",
      menu: false,
      menuBg: false,
      menuBtn: false,
      btncolor: "#e50914",
      bgcolor: "",
      bio: "",
      bank: [],
      btnloading: false,
      sheet: false,
      profile: false,
      picture: "",
      imageData: "",
      imgloading: false,
      image: "",
    };
  },
  components: {
    NavMenu,
    Bank,
    Notifications,
    BottomMenu,
    Password,
    ColorModePicker,
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),

    showColor() {
      if (typeof this.color === "string") return this.color;
      return JSON.stringify(
        Object.keys(this.color).reduce((color, key) => {
          color[key] = Number(this.color[key].toFixed(2));
          return color;
        }, {}),
        null,
        2
      );
    },
    swatchStyle() {
      const { color, menu } = this;
      return {
        backgroundColor: color,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: menu ? "50%" : "4px",
        transition: "border-radius 200ms ease-in-out",
      };
    },
    bgStyle() {
      const { bgcolor, menuBg } = this;
      return {
        backgroundColor: bgcolor,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: menuBg ? "50%" : "4px",
        transition: "border-radius 200ms ease-in-out",
      };
    },
    btnStyle() {
      const { btncolor, menuBtn } = this;
      return {
        backgroundColor: btncolor,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: menuBtn ? "50%" : "4px",
        transition: "border-radius 200ms ease-in-out",
      };
    },
  },

  beforeCreate(){
    if(localStorage.getItem('tippingsKey') == null){
     const auth = getAuth();
      signOut(auth)
        .then(() => {
          this.$router.push('/login')
        })
        .catch((error) => {
          console.log(error);
        });
   }
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      this.person =  user
      if (!user) {
        this.$router.push("/login");
      }
    });
  },
  created() {
    this.loading = true;
    getDoc(doc(db, "users", localStorage.getItem("tippingsKey")))
      .then((response) => {
        this.image = response.data().photoURL;
        this.username = response.data().username;
        this.fullname = response.data().name;
        this.email = response.data().email;
        this.phoneNumber = response.data().phoneNumber;
        this.facebook = response.data().facebook;
        this.twitter = response.data().twitter;
        this.instagram = response.data().instagram;
        this.youtube = response.data().youtube;
        this.tiktok = response.data().tiktok;
        this.linkedin = response.data().linkedin;
        this.bgcolor = response.data().bg;
        this.btncolor = response.data().btncolor;
        this.bio = response.data().bio;
        this.bank = response.data().bank;
      })
      .then(() => {
        this.loading = false;
      });
  },

  methods: {
    logOut() {
      localStorage.removeItem('tippingsKey')
      const auth = getAuth();
      signOut(auth)
        .then(() => {
          this.$router.push('/login')
        })
        .catch((error) => {
          console.log(error);
        });
    },

    imageModal() {
      this.$refs.imageUpload.click();
    },

    onFileChanged(event) {
      var input = event.target;
      if (input.files) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.image = e.target.result;
        };
        this.uploadImage = event.target.files;
        reader.readAsDataURL(input.files[0]);
      }
      this.imgloading = true;
      this.imageData = this.$refs.imageUpload.files[0];
      console.log(this.imageData.name);

      const storage = getStorage();

      // Create the file metadata
      /** @type {any} */
      const metadata = {
        contentType: "image/jpeg",
      };

      // Upload file and metadata to the object 'images/mountains.jpg'
      const storageRef = ref(storage, "images/" + this.imageData.name);
      const uploadTask = uploadBytesResumable(
        storageRef,
        this.imageData,
        metadata
      );

      // Listen for state changes, errors, and completion of the upload.
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          switch (snapshot.state) {
            case "paused":
              console.log("Upload is paused");
              break;
            case "running":
              console.log("Upload is running");
              break;
          }
        },
        (error) => {
          switch (error.code) {
            case "storage/unauthorized":
              // User doesn't have permission to access the object
              break;
            case "storage/canceled":
              // User canceled the upload
              break;

            // ...

            case "storage/unknown":
              // Unknown error occurred, inspect error.serverResponse
              break;
          }
        },
        () => {
          // Upload completed successfully, now we can get the download URL
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            const auth = getAuth();
            updateProfile(auth.currentUser, {
              photoURL: downloadURL,
            })
              .then(() => {
               this.picture = downloadURL;
               this.changeImage();
              })
              .catch((error) => {
                console.log(error)
                this.$swal({
        title: "Something went wrong 😥",
        text: "Sorry, we couldn't update your profile picture. It could be a network issue",
        icon: "error",
        confirmButtonText: "Yay!",
      });
              });
          });
        }
      );
    },

    async changeImage() {
      await updateDoc(doc(db, "users", localStorage.getItem("tippingsKey")), {
        photoURL: this.picture,
      });
      this.imgloading = false;
      this.$swal({
        title: "Profile picture Updated!",
        text: "Good job!. You've successfully updated your profile!",
        icon: "success",
        confirmButtonText: "Yay!",
      });
    },

    showProfile() {
      this.profile = true;
      this.step = 1;
    },
    showCustomization() {
      this.step = 2;
      this.sheet = true;
    },
    showPayment() {
      this.step = 3;
      this.sheet = true;
    },

    showNotifications() {
      this.step = 4;
      this.sheet = true;
    },

    showPassword() {
      this.step = 5;
      this.sheet = true;
    },

    async saveProfile() {
      this.btnloading = true;
      await updateDoc(doc(db, "users", localStorage.getItem("tippingsKey")), {
        name: this.fullname,
        phoneNumber: this.phoneNumber,
        facebook: this.facebook,
        twitter: this.twitter,
        instagram: this.instagram,
        tiktok: this.tiktok,
        linkedin: this.linkedin,
        youtube: this.youtube,
        bio: this.bio,
      })
      const auth = getAuth();
            updateProfile(auth.currentUser, {
              displayName: this.fullname,
            }).then(()=>{
               this.btnloading = false;
      this.$swal({
        title: "Profile updated Successfully!",
        text: "Congratulations, you've successfully updated your profile!",
        icon: "success",
        confirmButtonText: "Yay!",
      });
            })
    },
    async saveCustomization() {
      this.btnloading = true;
      await updateDoc(doc(db, "users", localStorage.getItem("tippingsKey")), {
        bg: this.bgcolor,
        btncolor: this.btncolor,
      });
      this.btnloading = false;
      this.$swal({
        title: "Customization Updated!",
        text: "Good job, you've successfully updated your page customization!",
        icon: "success",
        confirmButtonText: "Yay!",
      });
    },
  },
};
</script>
